import {Utils} from "./Utils";

export class Globals {
	static apiURL = '';
	static router;          // to redirect from js use: Globals.router.history.push("/")
	static mainPortal;
	static notificationPortal;
	static menuDrawer;
}
